import { useState, useEffect, useMemo} from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import NavHeader from '../shared/Nav-Header';
import styles from './settings.module.css';
import { DownIcon, UpIcon, CheckCircleIcon, XCircleIcon } from '../shared/icons/Icons';
import Notification from '../shared/Notification';
import SubscriptionPlans from '../shared/SubscriptionPlans';
import { useAuth } from '../context/AuthContext';


const Settings = () => {
    const [emailOrPhone, setEmailOrPhone] = useState('');
    const [name, setName] = useState('');
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showDeletePassword, setShowDeletePassword] = useState(false);
    const [deletePassword, setDeletePassword] = useState('');
    const [error, setError] = useState(''); 
    const navigate = useNavigate();
    const [changePasswordPopup, setChangePasswordPopup] = useState(false);
    const [deleteProfilePopup, setDeleteProfilePopup] = useState(false);
    const [notification, setNotification] = useState('');
    const token = useMemo(() => localStorage.getItem('token'), []);
    const { userId } = useAuth();
    // const { name: name } = useAuth();
    // const { email: emailOrPhone } = useAuth();
    const { profilePicture } = useAuth();
    const { subscriptionStatus } = useAuth();
    const { subscriptionExpiry } = useAuth();


    useEffect(() => {
        const fetchUserData = async () => {
            try {
                if (!token) {
                    localStorage.setItem('notification', 'You are currently Logged-out, Please login !');
                    navigate('/login'); // Redirect to login page if no token is found
                    return;
                }

                const response = await axios.get('/api/authApplicant/get-name-email', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setEmailOrPhone(response.data.emailOrPhone);
                setName(response.data.name);
            } catch (error) {
                // console.error('Error fetching user data:', error);
                // const errorMessage = error.message;
                // console.log(errorMessage);
                const errorMessage2 = error.response?.data?.message || 'An error occurred';
                setError(errorMessage2);
            }
        };

        fetchUserData();
        // fetchSUbscriptionStatus();
    }, [navigate]);

    const handleChangePassword = async () => {
        if (!oldPassword || !newPassword) {
            setNotification('Please fill in both password fields.');
            return;
        }
        try {
            const response = await axios.post('/api/authApplicant/change-password', {
                oldPassword,
                newPassword
                },
                {
                headers: {
                    Authorization: `Bearer ${token}`
                    }
            });
            // console.log("response.data.11", response.data);
            if(response.data.success){
                setOldPassword('');
                setNewPassword('');
            }
            setNotification(response.data.message);
            setChangePasswordPopup(false);
        } catch (error) {
            setNotification(error.response?.data?.message || 'Error changing password.');
            // console.error('Error changing password:1', error.message);
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('token');  
        // console.log('Logged out');
        navigate('/login');  
    };

    const handleDeleteProfile = async () => {
        setNotification('This settings is unavailabe tempoarily, we are sorry.');
        return;
        if (deletePassword) {
            try {
                const response = await axios.post('/api/authApplicant/delete-profile', {
                    password: deletePassword
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                        }
                        });
                // console.log(response.data.message);
                localStorage.removeItem('token'); // Remove the token from localStorage
                navigate('/'); // Redirect to login page
            } catch (error) {
                // console.error('Error deleting profile:', error);
            }
        } else {
            setNotification('Please enter your password to delete your profile.');
            // console.log('Please enter your password to delete your profile.');
        }
    };

    const handleOldPasswordChange = (e) => {
        setOldPassword(e.target.value);
    };

    const handleNewPasswordChange = (e) => {
        setNewPassword(e.target.value);
    };


    const handleDeletePasswordChange = (e) => {
        setDeletePassword(e.target.value);
    };
     const handleCloseNotification = () => {
        setNotification('');
    };
    

    return (
    <div>
        <NavHeader />
        {notification && (
            <Notification message={notification} onClose={handleCloseNotification} />
        )}
        <div className={styles.settingsContainer}>
            <div className={styles.header}>
                <div className={styles.avatar}>
                    <div className={styles.avatarIcon}>👤</div>
                </div>
                <h2 className={styles.title}>Settings</h2>
                <div className={styles.statusBadge}>
                    <span className={styles.statusDot}></span>
                    You are currently logged in
                </div>
            </div>

            <div className={styles.settingsCard}>
                <div className={styles.settingsInfo}>
                    <div className={styles.infoItem}>
                        <span className={styles.label}>📧 Email:</span>
                        <span className={styles.value}>{emailOrPhone}</span>
                    </div>
                    <div className={styles.infoItem}>
                        <span className={styles.label}>👤 Name:</span>
                        <span className={styles.value}>{name}</span>
                    </div>
                </div>
                <div className={styles.divider}></div>
                <div className={styles.mySubscription}>
                    <h3 className={styles.subscriptionTitle}>My Subscription</h3>
                        <div className={styles.subscriptionDetails}>
                            <div className={styles.subscriptionItem}>
                                <span className={styles.label}>Status:</span>
                                <span className={styles.value}>{subscriptionStatus === 'active' ? `Active` : 'Inactive '}</span>
                                {subscriptionStatus === 'active' ?<CheckCircleIcon/> : <XCircleIcon/>}
                            </div>
                            {subscriptionStatus === 'active' && (
                                <div className={styles.subscriptionItem}>
                                    <span className={styles.label}>Expiry:</span>
                                    <span className={styles.value}>{new Date(subscriptionExpiry).toLocaleDateString()}</span>
                                </div>
                            )}
                        </div>
                        
                </div>
                <SubscriptionPlans/>
                <br/>
            
                <label htmlFor="password" className={styles.inputLabel} onClick={() => setChangePasswordPopup(!changePasswordPopup)}>
                        🔒 Change Password {changePasswordPopup ? <UpIcon/> : <DownIcon/>}
                </label>
            
                {changePasswordPopup && 
                <>
                    <div className={styles.actionSection}>
                        <div className={styles.passwordChange}>
                            <div className={styles.enterPasswordContainer} >
                                <input 
                                    type={showOldPassword ? "text" : "password"}
                                    id="old-password" 
                                    value={oldPassword} 
                                    onChange={handleOldPasswordChange}
                                    className={styles.passwordInput}
                                    placeholder="Enter old password"
                                />
                                <span className={styles.eyeIcon} 
                                    onClick={() => setShowOldPassword(!showOldPassword)}
                                >
                                {showOldPassword ? '👁️' : '👁️‍🗨️'}
                                </span>
                            </div>
                            <div  className={styles.enterPasswordContainer}>
                                <input 
                                    type={showNewPassword ? "text" : "password"}
                                    id="new-password" 
                                    value={newPassword} 
                                    onChange={handleNewPasswordChange}
                                    className={styles.passwordInput}
                                    placeholder="Enter new password"
                                />
                                <span 
                                    onClick={() => setShowNewPassword(!showNewPassword)}
                                    className={styles.eyeIcon}
                                >
                                {showNewPassword ? '👁️' : '👁️‍🗨️'}
                                </span>
                            </div>
                            <button className={styles.changePasswordButton} onClick={handleChangePassword}>
                                Change Password
                            </button>
                        </div>
                    </div>
                </>
                }

                <label htmlFor="delete-password" className={styles.inputLabel} onClick={() => setDeleteProfilePopup(!deleteProfilePopup)}>
                    {deleteProfilePopup ?<>  🗑️ Enter Password to Delete Profile:<UpIcon/></> : <>🔒 Delete Profile<DownIcon/></>}
                </label>

                {deleteProfilePopup && 
                    <div className={styles.actionSection}>
                        <div className={styles.deleteProfile}>
                            <div  className={styles.enterPasswordContainer}>
                            <input 
                                type={showDeletePassword ? "text" : "password"}
                                id="delete-password" 
                                value={deletePassword} 
                                onChange={handleDeletePasswordChange}
                                className={styles.passwordInput}
                                placeholder="Enter password"
                            />
                            <span 
                                onClick={() => setShowDeletePassword(!showDeletePassword)}
                                className={styles.eyeIcon}
                            >
                            {showDeletePassword ? '👁️' : '👁️‍🗨️'}
                            </span>
                        
                            </div> 
                            <button className={styles.deleteButton} onClick={handleDeleteProfile}>
                                Delete Profile
                            </button>
                        </div>
                    </div>
                }

                <button className={styles.logoutButton} onClick={handleLogout}>
                    Logout
                </button>
                <div className={styles.warning}>
                    ⚠️ Profile deletion is permanent and cannot be undone
                </div>
                <div className={styles.contactUs}>
                    In case of any discrepancy, please contact us at <a href="mailto:reception@merilite.com">reception@merilite.com</a>
                </div>
            </div>
        </div>
    </div>
    );
};

export default Settings;